import { NavigationService } from '../../../../../navigation/navigation.service';
import { PagedResultGeneric } from '../../../../../model/paged-result.model';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';

@Component({
  selector: 'wl-new-invoice-dialog',
  templateUrl: './new-invoice-dialog.component.html',
  styleUrls: ['./new-invoice-dialog.component.less'],
    standalone: false
})
export class NewInvoiceDialogComponent implements OnInit {
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  public profileResults: PagedResultGeneric<ProfileMin>;

  private _show: boolean;

  constructor(private _navigationService: NavigationService) {}

  ngOnInit() {}

  setResults(profileResults: PagedResultGeneric<ProfileMin>) {
    this.profileResults = profileResults;
  }

  profileSelected(profile: ProfileMin) {
    this.show = false;
    this._navigationService.navigateToInvoiceCreate(profile.ProfileId);
  }
}
